<div class="form-div email-confirmation-div">
  <img src="assets/envelop-notification.svg" alt="email-confirmation" />
  <div class="text-div">
    <h2 i18n>Email Confirmation</h2>
    <p i18n>Please check your email and press on the link to verify your email.</p>
  </div>
  <div class="resend-email-div" i18n><p>Didn't receive the email?</p><a class="resend-email-link" (click)="customerSignupService.resendEmailButtonClicked()">Resend</a></div>

  <div class="alert alert-danger form-alert" *ngIf="customerSignupService.emailVerificationErrorMessage !== null">{{ customerSignupService.emailVerificationErrorMessage }}</div>
  <div class="alert alert-success form-alert" *ngIf="customerSignupService.emailVerificationSuccessMessage !== null">{{ customerSignupService.emailVerificationSuccessMessage }}</div>

</div>
